import { BaseBlockProps } from '../../defs/block';

export type BalloonBoxBlockID = 'balloonBox';

export type BalloonBoxBlockType = 'balloonBox';

export type BalloonBoxBlockProps = {
  type: BalloonBoxBlockType;
} & BaseBlockProps;

export const balloonBoxBlockProps: Record<
  BalloonBoxBlockID,
  BalloonBoxBlockProps
> = {
  balloonBox: {
    id: 'bbx',
    type: 'balloonBox',
    immobile: true,
    width: 3,
    height: 3,
  },
};

export const balloonBoxColors = ['blue', 'green', 'red', 'yellow'] as const;

const balloonBoxStateFlags = [
  'blueA',
  'blueB',
  'greenA',
  'greenB',
  'redA',
  'redB',
  'yellowA',
  'yellowB',
] as const;

export type BalloonBoxStateFlag = (typeof balloonBoxStateFlags)[number];

export type BalloonBoxState = Record<BalloonBoxStateFlag, boolean>;

export function balloonBoxStateToOption(state: BalloonBoxState): number {
  let option = 0;
  if (state.blueA) option += 1;
  if (state.blueB) option += 2;
  if (state.greenA) option += 4;
  if (state.greenB) option += 8;
  if (state.redA) option += 16;
  if (state.redB) option += 32;
  if (state.yellowA) option += 64;
  if (state.yellowB) option += 128;
  return option;
}

export function balloonBoxOptionToState(option: number): BalloonBoxState {
  return {
    blueA: (option & 1) === 1,
    blueB: (option & 2) === 2,
    greenA: (option & 4) === 4,
    greenB: (option & 8) === 8,
    redA: (option & 16) === 16,
    redB: (option & 32) === 32,
    yellowA: (option & 64) === 64,
    yellowB: (option & 128) === 128,
  };
}

export function balloonBoxOptionCheckStateComplete(
  state: BalloonBoxState,
): boolean {
  return Object.values(state).every((flag) => !!flag);
}
